import type { DesignSnackSettingsFormModel, ServerModel } from "../type";

type Props = {
	snackData: ServerModel;
};

export const serverModelToInputModel = ({ snackData }: Props): DesignSnackSettingsFormModel["InputModel"] => {
	const { hotelID, gtmID, subDomain, baseDomain, topPageSnackUUID } = snackData;

	const inputModel: DesignSnackSettingsFormModel["InputModel"] = {
		hotelID,
		subDomain,
		baseDomain,
		gtmID,
		topPageSnackUUID,
		guestPageVisibility: snackData.guestPageVisibilitySettings.snackVisibility,
	} satisfies DesignSnackSettingsFormModel["InputModel"];

	return inputModel;
};
